import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import i18n from 'i18next'

const getInitValue = () => {
  return 'it'
}

export interface LocaleState {
  value: string
}

export const localeSlice = createSlice({
  name: 'locale',
  initialState: {
    value: getInitValue(),
  },
  reducers: {
    setLocale: (state, { payload }: PayloadAction<LocaleState>) => {
      state.value = payload.value
      if (i18n) {
        void i18n.changeLanguage(payload.value)
      }
    },
  },
})

export const { setLocale } = localeSlice.actions
export default localeSlice.reducer
